import React from "react";
import FormattedDate from "../../../components/TimeStamp";
import SafeHtml from "@egovernments/digit-ui-module-common/src/sharedComponents/SafeHtml";

const PfarDetailsTable = ({ detailData }) => {
  const detailsArray = Array.isArray(detailData) ? detailData : [detailData];
console.log(detailData,"detailData in pfar");
  return (
    <div>
      <h3 style={{ fontWeight: "bold", marginBottom: "10px" }}>Purchasable Far Remark Details Summary</h3>
      <div style={{ overflowX: "auto", maxHeight: "300px", overflowY: "scroll" }}>
        <table
          border="1"
          cellPadding="8"
          width="100%"
          style={{
            borderCollapse: "collapse",
            minWidth: "800px",
            fontSize: "11px",
            position: "relative",
          }}
        >
          <thead style={{ backgroundColor: "rgba(52, 73, 94, 0.94)", position: "sticky", top: 0, zIndex: 2 }}>
            <tr style={{ fontSize: "14px", backgroundColor: "rgba(52, 73, 94, 0.94)", color: "#fff" }}>
              <th>User</th>
              <th>Designation</th>
              <th>Date & Time</th>
              <th>Remarks</th>
            </tr>
          </thead>
          <tbody>
            {detailsArray.map((item, index) => {
              const user = item?.userDetails || {};
              const createdTime = item?.auditDetails?.createdTime || null;
              const remarks = item?.remarksDetails?.developerRemarks;

              return (
                <tr key={index}>
                  <td>{user?.employeeName || user?.name || "-"}</td>
                  <td>{user?.designation || "-"}</td>
                  <td>
                    <FormattedDate timestamp={createdTime} />
                  </td>
                  <SafeHtml html={remarks || "-"} tag="td" />
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      
    </div>
  );
};

export default PfarDetailsTable;
